import invitationStatus from 'constants/invitationStatus';

import { BeneficiaryInvitationSummary } from 'modules/beneficiaries/components/BeneficiarySociety/types/BeneficiarySocietyTypes';

export const getIncentiveChart = (configuration?: {
  hasIncentiveChart?: boolean;
}) => configuration?.hasIncentiveChart !== false;

export const hasPendingInvitations = (
  invitations: BeneficiaryInvitationSummary[]
) => invitations.some((elem) => elem.status === invitationStatus.PENDING.value);

export const hasPlanWithInvitation = (
  invitations: BeneficiaryInvitationSummary[]
) => invitations.some((elem) => elem.hasInvitation);
